import React from "react";
import { Quote } from "lucide-react";

const testimonials = [
  {
    name: "Aarav Kapoor",
    title: "Sommelier",
    image: "https://i.pravatar.cc/150?img=32",
    quote:
      "This wine is nothing short of art. Bold, balanced, and perfectly aged — a true delight to the senses.",
  },
  {
    name: "Meera Shah",
    title: "Luxury Lifestyle Blogger",
    image: "https://i.pravatar.cc/150?img=45",
    quote:
      "The presentation, aroma, and depth of flavor — everything screams elegance. Simply divine.",
  },
  {
    name: "Rahul Verma",
    title: "Restaurant Critic",
    image: "https://i.pravatar.cc/150?img=52",
    quote:
      "An exceptional wine experience. Full-bodied, smooth, and sophisticated. Highly recommended.",
  },
];

const Testimonial = () => {
  return (
    <section className="bg-[--neutral-light-gray] py-20 px-6">
      <div className="max-w-6xl mx-auto text-center mb-14">
        <h2 className="text-3xl sm:text-4xl font-extrabold text-[--primary-wine]">
          Trusted by Wine Lovers
        </h2>
        <p className="mt-3 text-gray-600 text-sm sm:text-base">
          Hear what our connoisseurs have to say about our handcrafted wines.
        </p>
      </div>

      <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-3 max-w-6xl mx-auto">
        {testimonials.map((t, index) => (
          <div
            key={index}
            className="relative bg-white shadow-md border border-gray-100 rounded-xl p-6 flex flex-col justify-between h-full"
          >
            <Quote className="absolute top-4 right-4 text-[--accent-gold]" size={28} />

            <p className="text-gray-700 text-base mb-6 leading-relaxed italic">
              “{t.quote}”
            </p>

            <div className="flex items-center gap-4 mt-auto">
              <img
                src={t.image}
                alt={t.name}
                className="w-12 h-12 rounded-full border-2 border-[--accent-gold] object-cover"
              />
              <div className="text-left">
                <h4 className="text-[--primary-wine] font-semibold">{t.name}</h4>
                <p className="text-xs text-gray-500">{t.title}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Testimonial;
